import React from 'react';
import * as ReactDOMClient from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import App from './App';
import Auth0ProviderWithHistory from './components/Auth0Provider';
import reportWebVitals from './reportWebVitals';
import { TwitterProvider } from './TwitterContext';
import VerifyUser from "./components/VerifyUser";
import { useAuth0 } from "@auth0/auth0-react";
import NotFound from './components/NotFound';
import AuthDebugger from './components/AuthDebugger';
import Profile from './components/Profile';
import Detail from './components/Detail';

function RequireAuth({ children }) {
  const { isAuthenticated, isLoading } = useAuth0();

  // If the user is not authenticated, redirect to the home page
  if (!isLoading && !isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Otherwise, display the children (the protected page)
  return children;
}

const root = ReactDOMClient.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Auth0ProviderWithHistory>
      <TwitterProvider>
      <BrowserRouter>
          <Routes>
            <Route path="/verify-user" element={<VerifyUser />} />            
            <Route path="/" element={<App />} />
            <Route path="/home" element={<App />} />
            <Route path="/authDebugger" element={<AuthDebugger />} />
            <Route path="/profile/:id" element={
              <Profile />
            } />
            <Route path="/details/:tweetId" element={
              <Detail />
            } />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TwitterProvider>
    </Auth0ProviderWithHistory>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
